import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface UpdateAssessmentParams {
  assessmentText: string;
}

interface UpdateAssessmentResponse {
  documentReferences: fhirTypes.DocumentReference[];
}

export const useUpdateAssessment = ({
  patientId,
  motherEncounterId,
  encounterId,
  docRefId,
}: {
  patientId?: string;
  motherEncounterId?: string;
  encounterId?: string;
  docRefId?: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<UpdateAssessmentResponse, UpdateAssessmentParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.Assessment.UPDATE(patientId),
      mutationFn: (params) => {
        return axiosInstance.patch(`/charting/assessment/${docRefId}`, params);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.Assessment.DEFAULT({
            patientId,
            encounterId,
          }),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId,
            encounterId,
          }),
        });
      },
    },
  });
};
